export const signs: Record<string, string> = {
	sign_default: "A placa está em branco.",
	sign_playground_demo: "Bem-vindo ao nível de testes.",
	sign_wasteland_outpost: "Entrada das cavernas",
	sign_bullet_storage: "Depósito de munição",
};
